import { render, staticRenderFns } from "./regNPayResult.vue?vue&type=template&id=8065e000&"
import script from "./regNPayResult.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./regNPayResult.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./regNPayResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports